// TODO: Test with filters
// TODO: Animate in content (optional)
class InfiniteScroll {
  constructor({
    container = '#product-grid',
    pagination = '#product-pagination',
    offset = 0,
    callback = null,
  } = {}) {
    this.settings = { container, pagination, offset }

    this.container = document.querySelector(container)
    this.pagination = document.querySelector(pagination)
    this.callback = callback

    this.observer = new IntersectionObserver(this.observe.bind(this), {
      rootMargin: `0px 0px ${offset}px 0px`,
    })

    this.observer.observe(this.pagination)

    this.loadMoreButton = document.querySelector('#load-more-products');
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => {
        this.loadMore(false);
      });
    }
  }

  observe(entries, observer) {
    const entry = entries[0]

    if (entry.isIntersecting) {
      this.loadMore()

      observer.disconnect()
    }
  }

  async loadMore(continueLoading = true) {
    const result = await this.callback(this.settings)

    if (!result) {
      this.end()
    } else {
      if(continueLoading) {
        this.observer.observe(this.pagination)
      } else {
        this.disableScroll()
      }
    }
  }
  
  end() {
    this.pagination.remove()
    this.observer.disconnect()
  }

  destroy() {
    this.observer.disconnect()
  }
}

class ShopifyInfiniteScroll extends InfiniteScroll {
  constructor({
    container = '#product-grid',
    pagination = '#product-pagination',
    offset = 0,
    callback = null,
    transformCallback = null,
    buttonId = '#disable-infinite-scroll'
  } = {}) {
    super({ container, pagination, offset, callback, transformCallback })

    this.transformCallback = transformCallback
    this.button = document.querySelector(buttonId);
    this.status = document.querySelector('#infinite-scroll-status');

    if (this.button) {
      this.button.addEventListener('click', () => this.disableScroll(true));
    } else {
      console.error('Button element not found. Make sure to specify the correct button ID.');
    }
    
    if (window.location.href.includes('?page=') || window.location.href.includes('&page=')) {
      this.disableScroll()
      this.accessiblityLinks()
    }

    document.querySelector('#ProductGridContainer')?.addEventListener('click', (e) => {
      if (e.target.closest('a[href*="/products/"]')) {
        sessionStorage.setItem('plp', JSON.stringify({ y: scrollY, url: location.href }))
      }
    })

    if (document.documentElement.classList.contains('plp-restore-pending')) {
      this.observer.disconnect()
      this.restoreScroll()
    }
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && document.documentElement.classList.contains('plp-restore-pending')) {
        this.observer.disconnect()
        this.restoreScroll()
      }
    })
  }

  async restoreScroll() {
    const plp = JSON.parse(sessionStorage.getItem('plp') || '{}')
    const done = () => {
      sessionStorage.removeItem('plp')
      document.documentElement.classList.remove('plp-restore-pending')
      if (this.pagination && !this.container.classList.contains('grid--infinite-scroll-disabled')) {
        this.observer.observe(this.pagination)
      }
    }

    if (!plp.y || plp.url !== location.href) return done()

    while (document.body.scrollHeight < plp.y && this.pagination?.querySelector('a')) {
      const link = this.pagination.querySelector('a')
      const html = await fetch(link.href).then((r) => r.text())
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const grid = doc.querySelector(this.settings.container)
      const pag = doc.querySelector(this.settings.pagination)

      if (!grid) break
      this.container.insertAdjacentHTML('beforeend', grid.innerHTML)
      if (!pag?.querySelector('a')) {
        this.end()
        break
      }
      this.pagination.innerHTML = pag.innerHTML
    }

    window.scrollTo(0, plp.y)
    done()
  }

  async loadMore(continueLoading = true) {
    const paginationLink = this.pagination.querySelector('a')

    if (!paginationLink) {
      console.error('No pagination link found')
      return
    }

    const paginationUrl = paginationLink.href

    let response = await fetch(paginationUrl)

    if (this.transformCallback && typeof this.transformCallback === 'function') {
      response = this.transformCallback(response)
    }

    const markup = await response.text()

    const parser = new DOMParser()
    const newPage = parser.parseFromString(markup, 'text/html')

    const newContainer = newPage.querySelector(this.settings.container)
    const newPagination = newPage.querySelector(this.settings.pagination)
    this.container.insertAdjacentHTML('beforeend', newContainer.innerHTML)
    const firstNewLoadedCard = newContainer.querySelectorAll('.card .card__main')[0];
    let firstNewLoadedProductId = null;
    if(firstNewLoadedCard) {
      firstNewLoadedProductId = firstNewLoadedCard.getAttribute('data-product-id');
    }

    // Adds a class to the product card that is focused in order for accessibility
    const cards = document.querySelectorAll('.card');

    cards.forEach((card) => {
      card.addEventListener('focusin', () => {
        card.classList.add('card--focused');
      });

      card.addEventListener('focusout', () => {
        card.classList.remove('card--focused');
      });
    });

    if (this.callback && typeof this.callback === 'function') {
      // TODO: Add basic variables (current page etc.) to pass to callback
      this.callback(response)
    }

    if (!newPagination) {
      this.end()
    } else {
      this.pagination.innerHTML = newPagination.innerHTML
      if(continueLoading) {
        this.observer.observe(this.pagination)
      } else {
        this.disableScroll()
        if(firstNewLoadedProductId) {
          this.container.querySelector('.card__main[data-product-id="' + firstNewLoadedProductId + '"]').parentElement.querySelector('.card__link').focus();
        }
      }
    }
  }

  disableScroll(announce = false) {
    this.destroy()
    this.container.classList.add('grid--infinite-scroll-disabled')
    this.button?.setAttribute('aria-pressed', 'true')

    if (announce && this.status) {
      this.status.textContent = this.status.dataset.disabledMessage
    }
  }

  accessiblityLinks() {
    const mainLink = document.querySelector('#skip-to-content')
    const collectionLinkHTML = '<a class="skip-to-content-link" href="#product-grid">Skip to products</a>'
    const journalLinkHTML = '<a class="skip-to-content-link" href="#journal__grid">Skip to articles</a>'
    
    if (window.location.href.includes('/collections/') || window.location.href.includes('/search')) {
      mainLink.insertAdjacentHTML('beforebegin', collectionLinkHTML)
    } else if (window.location.href.includes('/blogs/')) {
      mainLink.insertAdjacentHTML('beforebegin', journalLinkHTML)
    }
  }
}
